import { FaTelegram, FaInstagram, FaTiktok } from "react-icons/fa6";
import { SOCIAL } from "@/config/social";

const ICONS = {
  telegram: FaTelegram,
  instagram: FaInstagram,
  tiktok: FaTiktok,
};

const COLORS = {
  telegram: "hover:bg-[#229ED9] hover:border-[#229ED9]",
  instagram: "hover:bg-[#E1306C] hover:border-[#E1306C]",
  tiktok: "hover:bg-black hover:border-black",
};

const ROUND_COLORS = {
  telegram: "bg-[#229ED9]",
  instagram: "bg-[#E1306C]",
  tiktok: "bg-black",
};

export function SocialLinks({ compact = false }) {
  if (compact) {
    return (
      <div data-testid="social-links" className="flex flex-col items-center gap-2">
        <p data-testid="social-band-title" className="font-display text-lg font-black uppercase leading-none tracking-tight text-zinc-950">
          Band e <span className="text-green-500">Fess</span>
        </p>
        <div className="flex items-center justify-center gap-3">
          {SOCIAL.links.map((s) => {
            const Icon = ICONS[s.platform];
            return (
              <a
                key={s.key}
                data-testid={`social-${s.key}`}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                title={s.label}
                className={`flex h-11 w-11 items-center justify-center rounded-full text-white shadow-md transition-transform hover:scale-110 ${ROUND_COLORS[s.platform]}`}
              >
                <Icon className="h-5 w-5" />
              </a>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div data-testid="social-links" className="space-y-3">
      <div className="text-center">
        <p data-testid="social-band-title" className="font-display text-3xl font-black uppercase leading-none tracking-tight text-zinc-950">
          Band e <span className="text-green-500">Fess</span>
        </p>
        <p className="mt-1 text-sm font-bold uppercase leading-tight tracking-wide text-zinc-600">
          {SOCIAL.headline}
        </p>
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        {SOCIAL.links.map((s) => {
          const Icon = ICONS[s.platform];
          return (
            <a
              key={s.key}
              data-testid={`social-${s.key}`}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group flex items-center justify-center gap-2 rounded-2xl border-2 border-zinc-950 bg-white px-3 py-2.5 font-bold text-zinc-950 transition-colors hover:text-white ${COLORS[s.platform]}`}
            >
              <Icon className="h-5 w-5 shrink-0" />
              <span className="truncate text-sm">{s.label}</span>
            </a>
          );
        })}
      </div>
    </div>
  );
}
